<div #mainMobileAppPreview></div>
